<template>
    <div id="audio-player-root" :class="{'sticky-audio-player' : stickyMode }">
        <div style="display:none">
            <audio
                ref="player"
                :id="playerid"
            >
                <source :src="url" type="audio/mpeg" />
            </audio>
        </div>

        <div class="">
            <div
                class="w-full bg-gray-200 border border-gray-300 px-5 py-3 mt-4 shadow-md"
            >
                <div id="player-row" class="inline-flex flex-wrap w-full max-w-5xl">
                    <div id="button-div" class="flex-initial pr-3">
                        <svg
                            @click="toggleAudio()"
                            v-show="!isPlaying"
                            class="h-7 w-7 text-gray-400"
                            :class="{ 'text-orange-600': audioLoaded, 'hover:text-orange-400': audioLoaded, 'cursor-pointer': audioLoaded }"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <svg
                            @click="toggleAudio()"
                            v-show="isPlaying"
                            class="h-7 w-7 text-orange-400 hover:text-orange-400 cursor-pointer"                            
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </div>

                    <div
                        id="progress-bar"
                        class="flex-grow bg-white border border-blue-200"
                    >
                        <div class="overlay-container relative w-full h-full">
                            <input
                                v-model="playbackTime"
                                type="range"
                                min="0"
                                :max="audioDuration"
                                class="slider w-full h-full"
                                id="position"
                                name="position"
                            />

                            <div v-show="!audioLoaded"
                            class="w-full absolute top-0 bottom-0 right-0 left-0 px-2 pointer-events-none"
                            style="color: #94bcec">
                            Loading please wait...
                            </div>
                            
                            <div
                                v-show="audioLoaded"
                                class="flex w-full justify-between absolute top-0 bottom-0 right-0 left-0 px-2 pointer-events-none"
                            >
                            
                                <span class="text-sm" style="color: #94bcec">00:00</span>

                                <span
                                    id="show-time"
                                    class="text-sm"
                                    style="color: #94bcec"
                                    v-html="displayTime()"
                                >
                                    00.00
                                </span>
                                
                            </div>

                            </div>
                        </div>
                        <div id="toggle-sticky" @click="toggleSticky()">


<svg id ="paperclip" title="Toggle player" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 hover:text-gray-500 m-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
</svg>

                        </div>
                    </div>
                </div>
            </div>
            <!-- outer gray border -->
        </div>
        <!-- white bg -->
    </div>
    <!-- root -->
</template>

<script>
//import { mapState } from 'vuex'
export default {
    props: ["url", "playerid"],
    /**
     * playbackTime = local var that syncs to audio.currentTime
     * audioDuration = total duration of audio file
     * audioLoaded = boolean (true when audio has loaded and is ready for play)
     * syncToState = boolean (set this to true to sync this audio player to the ConvoLine component)
     * isPlaying (computed) = boolean (true if audio is playing)
     *  -> if syncToState is true, value is tracked in state.audioPlaying 
     *  -> if syncToState is false, value is tracked in local audioPlaying )
     * audioPlaying = see above
     * stickyMode = boolean (set to true for player to display as a sticky footer)
     * listenerActive = boolean (true if playback listener is active)
     *
     **/

    data() {
        return {
            playbackTime: 0,
            audioDuration: 100,
            audioLoaded: false,
            syncToState: true,
            audioPlaying: false,
            stickyMode: false,
            listenerActive: false

        };
    },
    computed: {
        //...mapState({'audioPlaying'}),
        isPlaying: {
            // get audio play
            get: function() {
                //Get audio playback status from our application-wide state
                if (this.syncToState) return this.$store.state.audioPlaying
                else return this.audioPlaying;
            },
            // set audio pause state
            set: function(boolean) {
                //Update audio playback status in our application-wide state
                if (this.syncToState) this.$store.commit("SET_PLAYBACK_STATUS", boolean)
                else this.audioPlaying = boolean;
            }
        }
    },
    methods: {
        //Set the range slider max value equal to audio duration
        initSlider() {
            var audio = this.$refs.player;
            if (audio) {
                this.audioDuration = Math.round(audio.duration);
            }
        },
        //Toggle the sticky mode behavior of the audio player
        toggleSticky(){
            if (this.stickyMode === true)
                this.stickyMode = false
            else if (this.stickyMode === false)
                this.stickyMode = true

        },

        //Convert display time to 2 decimals
        displayTime() {
            var audio = this.$refs.player;
            if (audio) {
                var seconds = audio.currentTime;
                const format = val => `0${Math.floor(val)}`.slice(-2);
                var hours = seconds / 3600;
                var minutes = (seconds % 3600) / 60;

                return [minutes, seconds % 60].map(format).join(":");
            } else {
                return 0.0;
            }
        },

        //Playback listener function runs every 100ms while audio is playing
        playbackListener(e) {

            var audio = this.$refs.player;

            //Sync local 'playbackTime' var to audio.currentTime and update global state
            //Diff hack to prevent infinite loop between playback listener and $watcher
            var diff = Math.abs(this.playbackTime - audio.currentTime);
            if (diff > 0.25) {
                this.playbackTime = audio.currentTime;
                if (this.syncToState) this.$store.commit("SET_CURRENT_TIME", this.playbackTime);
            }
            
            //Add listeners for audio pause and audio end events
            audio.addEventListener("ended", this.endListener);
            audio.addEventListener("pause", this.pauseListener);
        },

        //Function to run when audio is paused by user
        pauseListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
        },
        //Function to run when audio play reaches the end of file
        endListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
        },
        //Remove listeners after audio play stops
        cleanupListeners() {
            var audio = this.$refs.player;
            audio.removeEventListener("freqtimeupdate", this.playbackListener);
            audio.removeEventListener("ended", this.endListener);
            audio.removeEventListener("pause", this.pauseListener);

            //console.log("all cleaned up!");
        },
        //Toggle audio start/stop
        toggleAudio() {
            var audio = this.$refs.player;
            if (audio.paused) {
                this.startAudio(audio);
            } else {
                audio.pause();
                this.isPlaying = false;
            }
        },
        startAudio(audio){
            //pause any audio already playing
            this.pauseAllAudio();
            //start audio 
            audio.play();
            //update play status in our global state
            this.isPlaying = true;
        },
        //Pause any other audio playing on the page before play start
        pauseAllAudio(){
            var audioElements = document.getElementsByTagName('audio');
            for (let audio of audioElements){
                this.isPlaying = false;
                audio.pause();
            }
        },
    },
    created() {},
    mounted: function() {
        // nextTick = code that will run only after the entire view has been rendered
        this.$nextTick(function() {
            //Wait for audio metadata to load, then get audio duration and set the input slider max value
            var audio = this.$refs.player;
            audio.addEventListener(
                "loadedmetadata",
                function(e) {
                    this.initSlider();
                }.bind(this)
            );

            //Listen for when audio is ready to play
            audio.addEventListener(
                "canplay",
                function(e) {
                    this.audioLoaded = true;
                }.bind(this)
            );

            /*
            //Listen for audio to begin play, then start playback listener function
            //Freqtimeupdate fires every 100ms while audio is playing
            audio.addEventListener(
                "play",
                function(e) {
                    this.$store.commit("SET_AUDIO_ID", audio.id);
                    this.initSlider();
                    this.isPaused = false;
                    console.log("Playback started.");

                    if (!this.listenerActive) {
                        this.listenerActive = true;
                        audio.addEventListener(
                            "freqtimeupdate",
                            this.playbackListener
                        );
                    }
                }.bind(this)
            );
            */

            //Listen for audio play to start, then launch playback listener function
            //Freqtimeupdate fires every 100ms while audio is playing
            this.$watch("isPlaying", function() {

                if (this.isPlaying){
                    var audio = this.$refs.player;
                    this.initSlider();

                    /*
                    console.log("Audio playback started.");
                    //move audio player to sticky bottom the first time the audio plays                    
                    console.log('firstplay status is: ' + this.$store.state.firstPlay);
                    if (this.$store.state.firstPlay){
                        this.$store.commit("SET_FIRSTPLAY_STATUS", false)
                        console.log('firstplay recorded');
                        this.stickyMode = true;
                    }
                    */
                   this.stickyMode = true;

                    //prevent starting multiple listeners at the same time
                    if (!this.listenerActive) {
                        this.listenerActive = true;
                        audio.addEventListener("freqtimeupdate", this.playbackListener);
                    }
            }

            });

            //Sync audio to user input from our range slider
            this.$watch("playbackTime", function() {
                var diff = Math.abs(
                    this.playbackTime - this.$refs.player.currentTime
                );
                //diff hack to prevent feedback loop with our playback listener
                if (diff > 0.25) {
                    this.$refs.player.currentTime = this.playbackTime;

                    //Update our global state
                    if (this.syncToState) this.$store.commit("SET_CURRENT_TIME", this.playbackTime);
                    
                }
            });

        });
    }
};
</script>

<style>
input[type="range"] {
    margin: auto;
    -webkit-appearance: none;
    position: relative;
    overflow: hidden;
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 0; /* iOS */
    background: transparent;
}

input[type="range"]:focus {
    outline: none;
}

::-webkit-slider-runnable-track {
    background: #fff;
}

/*
 * 1. Set to 0 width and remove border for a slider without a thumb
 */
::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 0; /* 1 */
    height: 20px;
    background: #fff;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    border: none; /* 2px solid #999; */
}

::-moz-range-track {
    height: 20px;
    background: #ddd;
}

::-moz-range-thumb {
    background: #fff;
    height: 20px;
    width: 0; /* 20px; */
    border: none; /* 3px solid #999; */
    border-radius: 0 !important;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    box-sizing: border-box;
}

::-ms-fill-lower {
    background: dodgerblue;
}

::-ms-thumb {
    background: #fff;
    border: 2px solid #999;
    height: 20px;
    width: 20px;
    box-sizing: border-box;
}

::-ms-ticks-after {
    display: none;
}

::-ms-ticks-before {
    display: none;
}

::-ms-track {
    background: #ddd;
    color: transparent;
    height: 20px;
    border: none;
}

::-ms-tooltip {
    display: none;
}

.sticky-audio-player {
  
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  z-index:1;
}
</style>
